import Oidc from "@axa-fr/react-oidc/dist/vanilla/oidc";

export const getAccessToken = () => {
    return Oidc.get('default')?.tokens?.accessToken;
};

export default getAccessToken;
